import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from "react-router-dom";
import { ChevronUp, ChevronDown, Edit2 } from 'react-feather';
import { useRemote } from '../../../Utils/Utils';
import { PAGES, ROUTE_PATHS, BannerContext } from '../../../InternalApiApp';
import Table from '../../../components/Table/Table';
import Page, { PageContentBodyGrid } from '../../Shared/Page/Page';
import PageGridItem from '../../Shared/Page/PageGridItem';
import PageGridDivider from '../../Shared/Page/PageGridDivider'
import SearchTermFilter from '../../../components/Input/SearchTermFilter'
import { formatDate } from '../../../Utils/Utils';

const FundsList = ({ }) => {
	const { setBannerBreadCrumbs } = useContext(BannerContext);
	const remote = useRemote();
	const [sortingColumn, setSortingColumn] = useState({ column: 'offerName', ascending: true })
	const [fundData, setFundData] = useState([]);
	const [hasFundSearchTerm, setHasFundSearchTerm] = useState(false);
	const [filteredFundData, setFilteredFundData] = useState([])
	const [loadingFunds, setLoadingFunds] = useState(true)

	const fundDataDisplaying = hasFundSearchTerm ? filteredFundData : fundData
	const history = useHistory()

	useEffect(() => {
		setBannerBreadCrumbs({ tab: 'Funds' })
		remote.get("/funds/funds2").then(funds => {
			setFundData(funds)
			setLoadingFunds(false)
		});
	}, [remote])

	// Clear Sorting
	useEffect(() => {
		setSortingColumn({ column: "offerName", ascending: true })
	}, [filteredFundData])

	const toggleSort = (column) => {
		if (column === null) {
			setSortingColumn({ column: "offerName", ascending: true })
			return
		}

		const ascending = sortingColumn.column === column ? !sortingColumn.ascending : true
		setSortingColumn({ column: column, ascending: ascending })
	}

	const sortTable = (dataToSort) => {
		if (sortingColumn.column === null) {
			return dataToSort
		}
		if (!dataToSort) {
			return dataToSort
		}

		let tableData = dataToSort
		const ascending = sortingColumn.ascending
		const column = sortingColumn.column;

		tableData.sort((a, b) => {
			const element1 = column === 'dateFundStarted' ? formatDate(a[column], true) : a[column]
			const element2 = column === 'dateFundStarted' ? formatDate(b[column], true) : b[column]
			if (!element1) {
				return 1;
			}
			if (!element2) {
				return -1;
			}
			return ascending ? element1.localeCompare(element2) : element2.localeCompare(element1)
		})
		return tableData
	}

	// Table widths and headers
	const fundsColWidths = ['31%', 11 + '%', 30 + '%', 11 + '%', 14 + '%', + 3 + '%'];
	const fundsHeaderLabels = [
		{ heading: 'Fund Name', field: 'fundName' },
		{ heading: 'Fund Number', field: 'fundNumber' },
		{ heading: 'Offer Name', field: 'offerName' },
		{ heading: 'Offer Number', field: 'offerNumber' },
		{ heading: 'Date Fund Started', field: 'dateStarted' }
	]

	const fundsHeaders = fundsHeaderLabels.map((column) => {
		return (
			{
				text: (
					<div className='sorting-header' onClick={() => toggleSort(column.field)} >
						{column.heading}
						{sortingColumn?.column === column.field && sortingColumn?.ascending === true ?
							<ChevronUp className='colour-text-primary' size={12} /> :
							<ChevronDown className={sortingColumn?.column === column.field ? 'colour-text-primary' : 'colour-text-neutral-dark-30'} size={12} />
						}
					</div>
				)
			}
		)
	})

	const fundsDataMap = (data) => data && data.map((fund, idx) => {
		const { fundName, fundNumber, offerName, offerNumber, dateStarted } = fund
		return (
			<tr key={idx} className='cursor-pointer' onClick={() => history.push(ROUTE_PATHS[PAGES.ADMIN] + '/fund-management/funds/' + fund.fundNumber)}>
				<td>{fundName}</td>
				<td>{fundNumber}</td>
				<td>{offerName}</td>
				<td>{offerNumber}</td>
				<td>{dateStarted ? dateStarted : "-"} </td>
				<td className='text-align-right'>
					<div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
						<Edit2 className='colour-text-primary' />
					</div>
				</td>
			</tr>
		);
	})

	const sortedDataToDisplay = sortTable(fundDataDisplaying)
	const dataToDisplay = !!sortedDataToDisplay ? fundsDataMap(sortedDataToDisplay) : null

	return (
		<Page noBanner>
			<PageContentBodyGrid rowGap="xl">
				<PageGridItem colSpan='12' gap='l' alignItems='center'>
					<SearchTermFilter
						size='small'
						width='m'
						placeholder='Search'
						isClearable
						dataSet={fundData}
						setFilteredData={setFilteredFundData}
						path={['fundName', 'fundNumber', 'offerName', 'offerNumber']}
						hasSearchTerm={(boolean) => setHasFundSearchTerm(boolean)}
					/>
					<p className='font-weight-medium p-medium mb-none'>{fundData && fundData.length ? `Total Funds: ${fundData?.length}` : ""}</p>
					<PageGridDivider />
				</PageGridItem>
				<PageGridItem colSpan='12' >
					<Table
						minWidth={1200}
						tableStyle={{ maxWidth: 1200 }}
						colWidths={fundsColWidths}
						headers={fundsHeaders}
						dataMap={dataToDisplay}
						id='scheme-and-funds-expandable-table'
						dataLoading={loadingFunds}
					/>
				</PageGridItem>
			</PageContentBodyGrid>
		</Page >
	)
}

export default FundsList;